module.exports = __webpack_public_path__ + "img/overall.59b0037f.png";